import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IProductBasket_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductBasket_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Connect: any;
  Connect_dummy: any;
  CartHeaderForPost: any[];
  CartHeaderForPost_dummy: any[];
  CartLineForPost: any[];
  CartLineForPost_dummy: any[];
  CartPaymentForPost: any[];
  CartPaymentForPost_dummy: any[];
  PostInstallmentSale: any;
  PostInstallmentSale_dummy: any;
  UpdateOrderOfficeAndOrderStore: any;
  UpdateOrderOfficeAndOrderStore_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  BasketList: any[];
  BasketList_dummy: any[];
  GetSelectCustomer: any[];
  GetSelectCustomer_dummy: any[];
  GetPaymentPlanDetailByCartHeaderId: any[];
  GetPaymentPlanDetailByCartHeaderId_dummy: any[];
  GetPaymentPlan: any[];
  GetPaymentPlan_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  BasketAllDeleted: any[];
  BasketAllDeleted_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  BasketLineDeleted: any[];
  BasketLineDeleted_dummy: any[];
  isComp684408Visible: "visible" | "hidden";
  isComp288359Visible: "visible" | "hidden";
  isComp104643Visible: "visible" | "hidden";
  isComp343426Visible: "visible" | "hidden";
  isComp248433Visible: "visible" | "hidden";
  isComp94148Visible: "visible" | "hidden";
  isComp10166Visible: "visible" | "hidden";
  isComp432366Visible: "visible" | "hidden";
  isComp648496Visible: "visible" | "hidden";
  isComp11111Visible: "visible" | "hidden";
  isComp152913Visible: "visible" | "hidden";
  isComp170942Visible: "visible" | "hidden";
  isComp140311Visible: "visible" | "hidden";
  isComp596169Enabled: "enabled" | "disabled";
  isComp582333Enabled: "enabled" | "disabled";
  isComp875136Enabled: "enabled" | "disabled";
  isComp352556Enabled: "enabled" | "disabled";
  isComp769718Enabled: "enabled" | "disabled";
}

export class ProductBasket_ScreenBase extends React.PureComponent<
  IProductBasket_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  productbasket_596169_value_kuikaSelectBoxRef: React.RefObject<any>;
  productbasket_582333_value_kuikaDateRef: React.RefObject<any>;
  productbasket_769718_value_kuikaDateRef: React.RefObject<any>;
  productbasket_73359_value_kuikaTableRef: React.RefObject<any>;
  productbasket_704638_value_kuikaTableRef: React.RefObject<any>;
  productbasket_140311_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "41382824-1443-48c1-a0a2-876945e61d96",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 266675, PropertyName: "value", Value: "Bırak" },
        { Id: 195678, PropertyName: "value", Value: "Adet Ürün Var" },
        { Id: 94148, PropertyName: "label", Value: "Ödeme Planı" },
        { Id: 10166, PropertyName: "label", Value: "Siparişi Onayla" },
        { Id: 767996, PropertyName: "value", Value: "SEPET" },
        { Id: 5850, PropertyName: "placeholder", Value: "Ürün Ara..." },
        {
          Id: 89325,
          PropertyName: "value",
          Value: "Sepet Açıklaması(İsteğe Bağlı)",
        },
        {
          Id: 35701,
          PropertyName: "placeholder",
          Value: "Sepete Açıklama Giriniz.",
        },
        { Id: 557471, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 701594, PropertyName: "value", Value: "Ödeme Planı" },
        {
          Id: 596169,
          PropertyName: "placeholder",
          Value: "Ödeme Planı Seçiniz...",
        },
        { Id: 36097, PropertyName: "value", Value: "Teslim Tarihi" },
        { Id: 582333, PropertyName: "placeholder", Value: "Teslim Tarihi" },
        { Id: 875136, PropertyName: "placeholder", Value: "Açıklama" },
        { Id: 608434, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 103394, PropertyName: "value", Value: "Peşinat" },
        { Id: 352556, PropertyName: "placeholder", Value: "15" },
        { Id: 132668, PropertyName: "value", Value: "Taksit Başlangıç Tarihi" },
        { Id: 769718, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 121427, PropertyName: "title", Value: "#" },
        { Id: 878762, PropertyName: "value", Value: "[datafield:linenum]" },
        { Id: 354859, PropertyName: "title", Value: "Vade Tarihi" },
        { Id: 373412, PropertyName: "value", Value: "[datafield:duedate]" },
        { Id: 112428, PropertyName: "title", Value: "Tutar" },
        { Id: 394885, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 45849, PropertyName: "label", Value: "Sepeti Temizle" },
        { Id: 177312, PropertyName: "value", Value: "Sepetteki Ürünler" },
        {
          Id: 704638,
          PropertyName: "nodatafoundmessage",
          Value: "Sepette Ürün Bulunmamaktadır!",
        },
        { Id: 795808, PropertyName: "title", Value: "Title" },
        { Id: 799965, PropertyName: "value", Value: "[datafield:productcode]" },
        {
          Id: 375582,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 772210, PropertyName: "value", Value: "[datafield:quantity]" },
        { Id: 102591, PropertyName: "value", Value: "Adet" },
        { Id: 170942, PropertyName: "value", Value: "[datafield:totalprice]" },
        { Id: 923055, PropertyName: "value", Value: "Ekleyen Satış Personeli" },
        {
          Id: 590916,
          PropertyName: "value",
          Value: "[datafield:salespersoncode]",
        },
        {
          Id: 868509,
          PropertyName: "value",
          Value: "[datafield:salespersonname]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productbasket_5850_value_kuikaTextInputRef = React.createRef();
    this.productbasket_596169_value_kuikaSelectBoxRef = React.createRef();
    this.productbasket_582333_value_kuikaDateRef = React.createRef();
    this.productbasket_769718_value_kuikaDateRef = React.createRef();
    this.productbasket_73359_value_kuikaTableRef = React.createRef();
    this.productbasket_704638_value_kuikaTableRef = React.createRef();
    this.productbasket_140311_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      Connect: "",
      CartHeaderForPost: [],
      CartLineForPost: [],
      CartPaymentForPost: [],
      PostInstallmentSale: "",
      UpdateOrderOfficeAndOrderStore: "",
      Notify: false,
      ReadFromLocalStorage: "",
      BasketList: [],
      GetSelectCustomer: [],
      GetPaymentPlanDetailByCartHeaderId: [],
      GetPaymentPlan: [],
      SetValueOf: "",
      ChangeVisibilityOf: "",
      BasketAllDeleted: [],
      TriggerEvent: "",
      BasketLineDeleted: [],
      isComp684408Visible: "hidden",
      isComp288359Visible: "visible",
      isComp104643Visible: "hidden",
      isComp343426Visible: "hidden",
      isComp248433Visible: "hidden",
      isComp94148Visible: "hidden",
      isComp10166Visible: "hidden",
      isComp432366Visible: "hidden",
      isComp648496Visible: "hidden",
      isComp11111Visible: "hidden",
      isComp152913Visible: "hidden",
      isComp170942Visible: "hidden",
      isComp140311Visible: "visible",
      isComp596169Enabled: "disabled",
      isComp582333Enabled: "disabled",
      isComp875136Enabled: "disabled",
      isComp352556Enabled: "disabled",
      isComp769718Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productbasket",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductBasketPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.ProductBasketPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productbasket",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productbasket",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductBasketPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductBasketPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      productbasket_596169_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.paymentPlanCode ?? undefined,
      productbasket_582333_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)?.deliveryDate ??
        undefined,
      productbasket_875136_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)?.description ??
        undefined,
      productbasket_352556_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.downPaymentAmount ?? undefined,
      productbasket_769718_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.installmentStartDate ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductBasketPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CartHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductBasketPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      CartHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      CartId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketList = result?.data.basketList;

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );
    stateVars.isComp248433Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432366Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp140311Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetSelectCustomer = result?.data.getSelectCustomer;
    formVars.productbasket_396817_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );
    formVars.productbasket_753632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );
    formVars.productbasket_741834_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );
    stateVars.isComp343426Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetPaymentPlanDetailByCartHeaderId =
      result?.data.getPaymentPlanDetailByCartHeaderId;

    formVars.productbasket_596169_value =
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null;
    formVars.productbasket_596169_options = stateVars.GetPaymentPlan;
    formVars.productbasket_582333_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );
    formVars.productbasket_875136_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );
    formVars.productbasket_352556_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );
    formVars.productbasket_769718_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );
    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp10166Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp648496Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp11111Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetPaymentPlan = result?.data.getPaymentPlan;

    formVars.productbasket_596169_value =
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null;
    formVars.productbasket_596169_options = stateVars.GetPaymentPlan;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp343426Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSelectCustomer !== undefined
            ? stateVars.GetSelectCustomer?.length > 0
              ? stateVars.GetSelectCustomer[0].cartHeaderId
              : null
            : this.state.GetSelectCustomer?.length > 0
            ? this.state.GetSelectCustomer[0].cartHeaderId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productbasket_396817_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].curAccCode
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].curAccCode
        : null
    );

    formVars.productbasket_753632_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerName
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerName
        : null
    );

    formVars.productbasket_741834_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetSelectCustomer !== undefined
        ? stateVars.GetSelectCustomer?.length > 0
          ? stateVars.GetSelectCustomer[0].customerPhone
          : null
        : this.state.GetSelectCustomer?.length > 0
        ? this.state.GetSelectCustomer[0].customerPhone
        : null
    );

    stateVars.isComp248433Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );

    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp10166Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432366Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp648496Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productbasket_596169_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null
    );

    stateVars.dataSource_596169 =
      stateVars.GetPaymentPlan ?? this.state.GetPaymentPlan;
    stateVars.dataSource_596169 =
      stateVars.GetPaymentPlan ?? this.state.GetPaymentPlan;
    formVars.productbasket_582333_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );

    formVars.productbasket_875136_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );

    stateVars.isComp11111Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productbasket_352556_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );

    formVars.productbasket_769718_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );

    stateVars.dataSource_73359 =
      stateVars.GetPaymentPlanDetailByCartHeaderId ??
      this.state.GetPaymentPlanDetailByCartHeaderId;

    stateVars.dataSource_704638 = stateVars.BasketList ?? this.state.BasketList;
    stateVars.isComp170942Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          "productbasket_704638_value",
          "totalPrice"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productbasket_140311_total = ReactSystemFunctions.value(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].totalRowCount
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].totalRowCount
        : null
    );

    stateVars.isComp140311Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductBasketComponent_606699_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_490835_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/customerselect") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductBasket",
      "CustomerSelect",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_94148_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/paymentscreen") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PaymentScreen",
      "CartHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductBasket",
      "PaymentScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_10166_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      CartHeaderId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      CartHeaderId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].customerCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].customerCode
            : null
        ),
        "string"
      ),
      description_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].description
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].description
            : null
        ),
        "string"
      ),
      officeCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].officeCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].officeCode
            : null
        ),
        "string"
      ),
      storeCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].storeCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].storeCode
            : null
        ),
        "string"
      ),
      warehouseCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].warehouseCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].warehouseCode
            : null
        ),
        "string"
      ),
      paymentPlanCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].paymentPlanCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].paymentPlanCode
            : null
        ),
        "string"
      ),
      lines_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.CartLineForPost),
        "any[]"
      ),
      lines_ItemCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartLineForPost?.itemCode
        ),
        "string"
      ),
      lines_ColorCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartLineForPost?.colorCode
        ),
        "string"
      ),
      lines_ItemDim1Code_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartLineForPost?.itemDim1Code
        ),
        "string"
      ),
      lines_Qty1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.CartLineForPost?.qty1),
        "number"
      ),
      lines_PriceVI_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.CartLineForPost?.priceVI),
        "number"
      ),
      lines_SalespersonCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartLineForPost?.salesPersonCode
        ),
        "string"
      ),
      lines_LineDescription_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartLineForPost?.lineDescription
        ),
        "string"
      ),
      lines_DeliveryDate_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.CartLineForPost?.deliveryDate
        ),
        "Date"
      ),
      cartHeaderId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_10166_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CartHeaderForPost = result?.data.cartHeaderForPost;
    stateVars.CartLineForPost = result?.data.cartLineForPost;
    stateVars.CartPaymentForPost = result?.data.cartPaymentForPost;
    stateVars.PostInstallmentSale = result?.data.postInstallmentSale;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_10166_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_10166_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      orderNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.PostInstallmentSale?.documentNumber
        ),
        "string"
      ),
      ordererOfficeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].officeCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].officeCode
            : null
        ),
        "string"
      ),
      ordererStoreCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CartHeaderForPost !== undefined
            ? stateVars.CartHeaderForPost?.length > 0
              ? stateVars.CartHeaderForPost[0].storeCode
              : null
            : this.state.CartHeaderForPost?.length > 0
            ? this.state.CartHeaderForPost[0].storeCode
            : null
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.PostInstallmentSale?.isSuccess
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ProductBasket/ProductBasketComponent_10166_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.ProductBasketComponent_10166_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.ProductBasketComponent_10166_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_10166_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        this.state.PostInstallmentSale?.responseMessage
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_10166_onClick3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductBasketComponent_10166_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.PostInstallmentSale?.isSuccess
        ),
        "1"
      )
    ) {
      const __currentPath = (
        window.location.hash
          ? window.location.hash.replace(/^#/, "").split("?")[0]
          : window.location.pathname.split("?")[0]
      ).toLowerCase();
      if (__currentPath !== "/basketreports") {
        this.context.setMasterPageInitLoaded(false);
        this.context.setMasterPageRecurringLoaded(false);
        this.context.setShouldTriggerPageInit(true);
      }
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "ProductBasket",
        "BasketReports",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ProductBasketComponent_5850_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productbasket_5850_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_5850_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketList = result?.data.basketList;

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );
    stateVars.isComp248433Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432366Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp140311Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_5850_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_5850_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "productbasket_140311_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );

    stateVars.dataSource_704638 = stateVars.BasketList ?? this.state.BasketList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_104643_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp684408Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp288359Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp104643Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_288359_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp684408Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp104643Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp288359Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_45849_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_45849_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketAllDeleted = result?.data.basketAllDeleted;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_45849_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_45849_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.BasketAllDeleted !== undefined
          ? stateVars.BasketAllDeleted?.length > 0
            ? stateVars.BasketAllDeleted[0].message
            : null
          : this.state.BasketAllDeleted?.length > 0
          ? this.state.BasketAllDeleted[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_45849_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductBasketComponent_45849_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_45849_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketList = result?.data.basketList;

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );
    stateVars.isComp248433Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432366Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp140311Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_45849_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_45849_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "productbasket_140311_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "productbasket_5850_value",
        "string"
      ),
      "",
      null,
      false
    );
    await this.ProductBasketPageInit();

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );

    stateVars.dataSource_704638 = stateVars.BasketList ?? this.state.BasketList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductBasketComponent_881516_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartLineId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "productbasket_704638_value", "id"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_881516_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketLineDeleted = result?.data.basketLineDeleted;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_881516_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.BasketLineDeleted !== undefined
          ? stateVars.BasketLineDeleted?.length > 0
            ? stateVars.BasketLineDeleted[0].message
            : null
          : this.state.BasketLineDeleted?.length > 0
          ? this.state.BasketLineDeleted[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_881516_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productbasket_140311_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "ProductBasket/ProductBasketComponent_881516_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.BasketList = result?.data.basketList;

      formVars.productbasket_6888_value = ReactSystemFunctions.toString(
        this,
        stateVars.BasketList !== undefined
          ? stateVars.BasketList?.length > 0
            ? stateVars.BasketList[0].cartTotalQuantity
            : null
          : this.state.BasketList?.length > 0
          ? this.state.BasketList[0].cartTotalQuantity
          : null
      );
      stateVars.isComp248433Visible =
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp94148Visible =
        (ReactSystemFunctions.isNotEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
              ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
                ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
                : null
              : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        ) &&
          ReactSystemFunctions.isGreaterThan(
            ReactSystemFunctions.value(
              this,
              stateVars.BasketList !== undefined
                ? stateVars.BasketList?.length > 0
                  ? stateVars.BasketList[0].cartTotalQuantity
                  : null
                : this.state.BasketList?.length > 0
                ? this.state.BasketList[0].cartTotalQuantity
                : null
            ),
            ReactSystemFunctions.convertToTypeByName("0", "string")
          )) === true
          ? "visible"
          : "hidden";
      stateVars.isComp432366Visible =
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp140311Visible =
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        ) === true
          ? "visible"
          : "hidden";
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "productbasket_5850_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_881516_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        true
      )
    ) {
      formVars.productbasket_6888_value = ReactSystemFunctions.toString(
        this,
        stateVars.BasketList !== undefined
          ? stateVars.BasketList?.length > 0
            ? stateVars.BasketList[0].cartTotalQuantity
            : null
          : this.state.BasketList?.length > 0
          ? this.state.BasketList[0].cartTotalQuantity
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        true
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.dataSource_704638 =
        stateVars.BasketList ?? this.state.BasketList;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductBasketComponent_881516_onClick7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductBasketComponent_881516_onClick7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketLineDeleted !== undefined
            ? stateVars.BasketLineDeleted?.length > 0
              ? stateVars.BasketLineDeleted[0].success
              : null
            : this.state.BasketLineDeleted?.length > 0
            ? this.state.BasketLineDeleted[0].success
            : null
        ),
        true
      )
    ) {
      formVars.productbasket_140311_total = ReactSystemFunctions.value(
        this,
        stateVars.BasketList !== undefined
          ? stateVars.BasketList?.length > 0
            ? stateVars.BasketList[0].totalRowCount
            : null
          : this.state.BasketList?.length > 0
          ? this.state.BasketList[0].totalRowCount
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  ProductBasketComponent_140311_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartHeaderId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      SearchText_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productbasket_5850_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productbasket_140311_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductBasket/ProductBasketComponent_140311_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BasketList = result?.data.basketList;

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );
    stateVars.isComp248433Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp94148Visible =
      (ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].plansave
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].plansave
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(
            this,
            stateVars.BasketList !== undefined
              ? stateVars.BasketList?.length > 0
                ? stateVars.BasketList[0].cartTotalQuantity
                : null
              : this.state.BasketList?.length > 0
              ? this.state.BasketList[0].cartTotalQuantity
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("0", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432366Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp140311Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          stateVars.BasketList !== undefined
            ? stateVars.BasketList?.length > 0
              ? stateVars.BasketList[0].cartTotalQuantity
              : null
            : this.state.BasketList?.length > 0
            ? this.state.BasketList[0].cartTotalQuantity
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductBasketComponent_140311_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductBasketComponent_140311_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.productbasket_6888_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].cartTotalQuantity
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].cartTotalQuantity
        : null
    );

    stateVars.dataSource_704638 = stateVars.BasketList ?? this.state.BasketList;
    formVars.productbasket_140311_total = ReactSystemFunctions.value(
      this,
      stateVars.BasketList !== undefined
        ? stateVars.BasketList?.length > 0
          ? stateVars.BasketList[0].totalRowCount
          : null
        : this.state.BasketList?.length > 0
        ? this.state.BasketList[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductBasketPageInit();
    }
  }
}
